import { FormikErrors, FormikProps, withFormik } from 'formik'
import { t } from 'i18next'
import React, { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { Form } from '@lib/formik'
import { useNavigate } from '@lib/react-router-dom'

import { Button } from '@ui/components/Button'

import { TickmillCompaniesEnum, getTickmillPublicDomain } from '@utils/companyName.utils'
import { FormSubmitValues } from '@utils/formValidation'

import { createFormField } from '@global/formField/FormField'

import { FieldWrapper } from '@shared/components/FieldWrapper'

import styles from './ForgotPasswordPage.module.scss'

export interface ForgotPasswordFormValues {
  email: string
  communicationLanguageId: string
  tickmillPublicDomain: string
}

const EmailField = createFormField<ForgotPasswordFormValues>()

const ForgotPasswordFormUI: React.FC<FormikProps<ForgotPasswordFormValues> & OuterProps> = (
  props
) => {
  const { handleSubmit, setSubmitting, isSubmitting, isValid } = props

  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmitForm = (event: SyntheticEvent) => {
    event.preventDefault()
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <Form className={styles.form} onSubmit={handleSubmitForm}>
      <FieldWrapper>
        <EmailField
          name='email'
          type='email'
          label={t('Email Address')}
          placeholder={t('Email Address')}
          wrapperClassname={styles.field}
        />
        <div className={styles.buttonBox}>
          <Button.Primary size='lg' disabled={!isValid} loading={isSubmitting} type='submit'>
            {t('Reset')}
          </Button.Primary>
          <Button.Secondary size='lg' onClick={() => navigate('/login')}>
            {t('Cancel')}
          </Button.Secondary>
        </div>
      </FieldWrapper>
    </Form>
  )
}

interface OuterProps {
  entity: TickmillCompaniesEnum
  email?: string
  onSubmit(values: FormSubmitValues<ForgotPasswordFormValues>): Promise<void>
}

export const ForgotPasswordForm = withFormik<OuterProps, ForgotPasswordFormValues>({
  mapPropsToValues: (props) => {
    return {
      email: props?.email || '',
      communicationLanguageId: 'en',
      tickmillPublicDomain: getTickmillPublicDomain(),
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<ForgotPasswordFormValues> = {}

    if (!values.email) {
      errors.email = t('Validation.Required')
    }
    return errors
  },
  enableReinitialize: true,
})(ForgotPasswordFormUI)
